module.exports = __webpack_public_path__ + "static/media/rohit.9392c3c8.jpeg";